// extracted by mini-css-extract-plugin
export default {"labels":"LoyaltyRewardTypeLabels_labels__vXFQE","more":"LoyaltyRewardTypeLabels_more__-wZ3L"};